import { ClipboardList, Info } from 'lucide-react';

export const EmptyState = () => {
  return (
    <div className="w-full h-[82vh] flex flex-col items-center justify-center py-20 bg-white rounded-xl">
      <div className="relative mb-6">
        <ClipboardList className="w-16 h-16 text-gray-300" />
        <Info className="w-4 h-4 text-gray-300 absolute -top-1 -right-1" />
      </div>
      <p className="text-gray-500 text-lg">You don't have any recent sales</p>
    </div>
  );
};
